
import { Component, Prop } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'

/** 对应后端 AMOUNT_TYPE（src/common/contants/index.contants.ts） */
const AMOUNT_TYPE_NAME = {
  1: '充值',
  2: '消费',
  3: '重新付款退款',
  4: '订单退款',
  5: '系统新增',
  6: '系统减少',
}
/** 记为减少的方向：消费、系统减少，其余为增加 */
const REDUCE_TYPES = [2, 6]

@Component({})
export default class extends ListViewVue {

  @Prop()
  userId: any;

  typeList = Object.keys(AMOUNT_TYPE_NAME).map((key) => {
    return { name: AMOUNT_TYPE_NAME[key], value: Number(key) }
  });

  getTypeName(type) {
    return AMOUNT_TYPE_NAME[type] || "-";
  }

  isReduce(type) {
    return REDUCE_TYPES.indexOf(Number(type)) > -1;
  }

  getValue(row) {
    return `${this.isReduce(row.type) ? '-' : '+'}${row.amount}`;
  }

  getCondition() {
    return {
      type: "",
      startTime: "",
      endTime: "",
    }
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  async getList() {
    let data: any = { ...this.mesureData, id: this.userId };
    // 空字符串会让后端匹配 type='' / 转出非法日期，直接不传这几个字段
    ['type', 'startTime', 'endTime'].forEach((key) => {
      if (data[key] === '' || data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });
    return this.$post("/manager/user/amount-log-list", data);
  }
}
